export default {
    booking: {
        services: {
            delete: "Are you sure you want to delete this service?",
            full: "Is your restaurant full?",
            removeFull: "Open the service to reservations?",
            serviceBuilderV2Migration:
                "This action is irreversible. Existing services will be converted to the new editor: enabled bank imprint becomes secured card + bank imprint, enabled prepayment becomes secured card + prepayment, and other services remain without secured payment. Do you want to continue?",
            openServiceForDate: 'The "{service}" service will be open for reservations for {date}. Do you want to continue?',
            openSlotForDate: 'The {hour} slot for the "{service}" service will be open for reservations for {date}. Do you want to continue?',
        },
        menus: {
            delete: "Are you sure you want to delete this menu?",
        },
    },
};
